module.exports = __webpack_public_path__ + "static/volume7-43e5f0cb516466f9c29b44bd7392c00a.png";